export const ShipmentCarrierOptions = [
  {
    key: 'select_carrier',
    value: '',
    label: 'Select Carrier',
  },
  {
    key: 'ups',
    value: 'ups',
    label: 'UPS',
  },
  {
    key: 'usps',
    value: 'usps',
    label: 'USPS',
  },
  {
    key: 'fedex',
    value: 'fedex',
    label: 'FEDEX',
  },
  {
    key: 'dhl',
    value: 'dhl',
    label: 'DHL',
  },
  {
    key: 'apc_postal',
    value: 'apc_postal',
    label: 'APC Postal',
  },
  {
    key: 'australia_post',
    value: 'australia_post',
    label: 'Australia Post',
  },
  {
    key: 'aramex',
    value: 'aramex',
    label: 'Aramex',
  },
  {
    key: 'asendia_us',
    value: 'asendia_us',
    label: 'Asendia',
  },
  {
    key: 'axlehire',
    value: 'axlehire',
    label: 'AxleHire',
  },
  {
    key: 'borderguru',
    value: 'borderguru',
    label: 'BorderGuru',
  },
  {
    key: 'boxberry',
    value: 'boxberry',
    label: 'Boxberry',
  },
  {
    key: 'bring',
    value: 'bring',
    label: 'Bring',
  },
  {
    key: 'canada_post',
    value: 'canada_post',
    label: 'Canada Post',
  },
  {
    key: 'cdl',
    value: 'cdl',
    label: 'CDL',
  },
  {
    key: 'correios_br',
    value: 'correios_br',
    label: 'Correios Brazil',
  },
  {
    key: 'correos_espana',
    value: 'correos_espana',
    label: 'Correos Espana',
  },
  {
    key: 'collect_plus',
    value: 'collect_plus',
    label: 'CollectPlus',
  },
  {
    key: 'couriersplease',
    value: 'couriersplease',
    label: 'CouriersPlease',
  },
  {
    key: 'deutsche_post',
    value: 'deutsche_post',
    label: 'Deutsche Post',
  },
  {
    key: 'dhl_benelux',
    value: 'dhl_benelux',
    label: 'DHL Benelux',
  },
  {
    key: 'dhl_germany',
    value: 'dhl_germany',
    label: 'DHL Germany',
  },
  {
    key: 'dhl_ecommerce',
    value: 'dhl_ecommerce',
    label: 'DHL eCommerce',
  },
  {
    key: 'dhl_express',
    value: 'dhl_express',
    label: 'DHL Express',
  },
  {
    key: 'dpd_germany',
    value: 'dpd_germany',
    label: 'DPD Germany',
  },
  {
    key: 'dpd_uk',
    value: 'dpd_uk',
    label: 'DPD UK',
  },
  {
    key: 'estafeta',
    value: 'estafeta',
    label: 'Estafeta',
  },
  {
    key: 'fastway_australia',
    value: 'fastway_australia',
    label: 'Fastway Australia',
  },
  {
    key: 'gls_de',
    value: 'gls_de',
    label: 'GLS Germany',
  },
  {
    key: 'gls_fr',
    value: 'gls_fr',
    label: 'GLS France',
  },
  {
    key: 'globegistics',
    value: 'globegistics',
    label: 'Globegistics',
  },
  {
    key: 'gophr',
    value: 'gophr',
    label: 'Gophr',
  },
  {
    key: 'gso',
    value: 'gso',
    label: 'GSO',
  },
  {
    key: 'hermes_uk',
    value: 'hermes_uk',
    label: 'Hermes UK',
  },
  {
    key: 'hongkong_post',
    value: 'hongkong_post',
    label: 'HongKong Post',
  },
  {
    key: 'lasership',
    value: 'lasership',
    label: 'Lasership',
  },
  {
    key: 'mondial_relay',
    value: 'mondial_relay',
    label: 'Mondial Relay',
  },
  {
    key: 'new_zealand_post',
    value: 'new_zealand_post',
    label: 'New Zealand Post',
  },
  {
    key: 'newgistics',
    value: 'newgistics',
    label: 'Newgistics',
  },
  {
    key: 'nippon_express',
    value: 'nippon_express',
    label: 'Nippon Express',
  },
  {
    key: 'ontrac',
    value: 'ontrac',
    label: 'OnTrac',
  },
  {
    key: 'orangeds',
    value: 'orangeds',
    label: 'OrangeDS',
  },
  {
    key: 'parcel',
    value: 'parcel',
    label: 'Parcel',
  },
  {
    key: 'posti',
    value: 'posti',
    label: 'Posti',
  },
  {
    key: 'purolator',
    value: 'purolator',
    label: 'Purolator',
  },
  {
    key: 'rr_donnelley',
    value: 'rr_donnelley',
    label: 'RR Donnelley',
  },
  {
    key: 'russian_post',
    value: 'russian_post',
    label: 'Russian Post',
  },
  {
    key: 'sendle',
    value: 'sendle',
    label: 'Sendle',
  },
  {
    key: 'skypostal',
    value: 'skypostal',
    label: 'SkyPostal',
  },
  {
    key: 'stuart',
    value: 'stuart',
    label: 'Stuart',
  },
  {
    key: 'yodel',
    value: 'yodel',
    label: 'Yodel',
  },
  {
    key: 'carrier_not_found',
    value: 'carrier_not_found',
    label: 'Carrier not found',
  },
];
